import { PrimaryButton, ButtonSize } from "@uni-of-exeter/digital.lib.react.ui.kit"
import { APP_URLS } from "../../../routes/paths";
import { useRouter } from "../../../routes/hooks";
import '../styles/resource-bookmark-toast.css'
import { APP_TEXT } from "../../../const/app-text";
import { useBookmarkToastMessage } from "../../../hooks/custom/bookmarking/use-bookmark-toast";

type ResourceBookmarkToastText = {
    resourceTitle: string;
    messageText: string;
}

export interface ResourceBookmarkToastProps {
    resourceId: string;
    isBookmarked: boolean;
    text: ResourceBookmarkToastText;
}

export const ResourceBookmarkToast = (
    {text, isBookmarked, resourceId, }: ResourceBookmarkToastProps
): JSX.Element => {
    const router = useRouter();
    const {
        undoBtnVisible,
        handleUndoClick,
    } = useBookmarkToastMessage();

    const messageTextClassName = isBookmarked 
        ? "messageTextShort"
        : "messageTextFullSize";

    return (
        <div className="bookmarkedResourceToastWrapper">

            <div className={`messageText ${messageTextClassName}`}>
                <b>{text.resourceTitle}</b> {text.messageText} 
            </div> 

            {!!isBookmarked && 
                <PrimaryButton 
                    buttonSize={ButtonSize.Small} 
                    className="viewBookmarksBtn" 
                    label={APP_TEXT.components.toast.bookmarking.viewBookmarksBtnText}
                    severity="success"
                    aria-label={APP_TEXT.components.toast.bookmarking.accessibility.viewBookmarksBtnLabel}
                    onClick={() => {
                        router.push(APP_URLS.bookmarks());
                    }}
                />
            }

            <PrimaryButton 
                buttonSize={ButtonSize.Small} 
                className={`undoBookmarkBtn ${undoBtnVisible ? 'enabled' : 'disabled'}`} 
                label={APP_TEXT.components.toast.bookmarking.undoBookmarkActionBtnText}
                severity="success"
                aria-label={APP_TEXT.components.toast.bookmarking.accessibility.undoBookmarkActionBtnLabel}
                onClick={(event) => {
                    event.preventDefault();
                    handleUndoClick(isBookmarked, resourceId);
                }}
            />
        </div>
    )
};